import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import CustomInput from "../../../Subcomponents/CustomInput";
import { useState } from "react";
import cssClasses from "./NewFolderModal.module.css";
import Button from "../../../Subcomponents/Button";
import { useEffect } from "react";

const NewFolderModal = ({
  label,
  open,
  handleClose,
  submitHandler,
  nameValue = "",
}) => {
  const [name, setName] = useState("");

  useEffect(() => {
    setName(nameValue);
  }, []);
  return (
    <Modal
      open={open}
      onClose={() => handleClose({ flag: false })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.mainContainer}>
          <Box className={cssClasses.inputContainer}>
            <p style={{ fontSize: "14px", marginBottom: "10px" }}>{label}</p>
            <CustomInput
              placeholder={"Enter Folder Name"}
              inputType="text"
              value={name}
              handleChange={(_value) => {
                if(_value !== "" && _value.replaceAll(' ', '').length > 0){
                setName(_value);
                }else{
                  setName("")
                }
              }}
              // disabled={}
            />
          </Box>
        </div>

        <div className={cssClasses.footer}>
          {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
          <div>
            <Button
              style={{ color: "#344054", backgroundColor: "#ffffff" }}
              btnName={"Cancel"}
              clicked={() => handleClose({ flag: false })}
            />
          </div>
          <div>
            <Button
              style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
              btnName={nameValue !== "" ? "Rename" : "Create"}
              clicked={() => {
                submitHandler(name);
              }}
              disable={name === ""}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default NewFolderModal;
